export const initialState = {isAuthenticated: false};

export const isAuthenticated = (state = initialState) => !!state.isAuthenticated;

export const getTestResult = (state = initialState) => state.testResult;
